import Keycloak from 'keycloak-js';

const authDev = {
  auth_url: 'https://id.skunkworks.ai/auth',
  realm: 'staging',
  access_token_url: 'https://id.skunkworks.ai/auth/realms/staging/protocol/openid-connect/token',
  client_id: 'viana-portal',
  client_secret: 'c2f34191-5f73-4699-91d2-4283fd97e81c',
  scope: 'openid user',
  powerBIReportID: 'e13cb171-aacd-4e9c-b5d9-7a2f24926b10',
  superset: {
    baseUrl: 'https://superset-dev.internal.viana.ai',
    coatro: '82ac9969-25dd-4979-95a4-88d7c5844300',
    coeffe: '78986180-b7bc-43cc-bad8-08d9bcb4b0ef',
    trafficMeasurement: 'f9abf10e-c5df-420b-be06-4ce3b2712651',
    coffeeVehicle: 'fc1c74d3-21b3-4352-bfd2-b53006b83436'
  }
};

const endpointsDev = {
  environment: 'dev',
  base_url: 'https://dev.services.api.viana.ai/',
  base_url_insights: 'https://dev.insights.api.viana.ai/',
  admin_url: 'https://dev.admin.internal.viana.ai/'
};

const authDevGCP = {
  auth_url: 'https://dev-gcp.id2.internal.viana.ai/auth',
  realm: 'staging',
  access_token_url: 'https://dev-gcp.id2.internal.viana.ai/auth/realms/staging/protocol/openid-connect/token',
  client_id: 'viana-portal',
  client_secret: 'c2f34191-5f73-4699-91d2-4283fd97e81c',
  scope: 'openid user',
  powerBIReportID: '4539fb05-ba4a-4f69-b43b-75b6a48691d9',
  powerBIGroupID: ' 13834247-2464-49f5-b013-b35c254e090a',
  superset: {
    baseUrl: 'https://dev-gcp.superset.internal.viana.ai',
    coatro: {
      default: '',
      meldcx: '28bb7b62-7553-4a06-8910-0be4348759be',
      pg: '',
    },
    coeffe: {
      default: '',
      meldcx: '7210dddc-b271-4a9d-99b6-dadf27c4d23d',
      pg: '',
      onq: '174c8458-3896-4990-b571-f5e37c445c9e',
    },
    trafficMeasurement: 'f9abf10e-c5df-420b-be06-4ce3b2712651',
    // coffeeVehicle: 'fc1c74d3-21b3-4352-bfd2-b53006b83436'
    coffeeVehicle: {
      default: '',
      meldcx: '',
      pg: '',
      onq: '',
      bsign: 'fc1c74d3-21b3-4352-bfd2-b53006b83436',
    },
  }
};

const authDevGCP2 = {
  auth_url: 'https://dev-gcp.id2.internal.viana.ai/auth',
  realm: 'staging',
  access_token_url: 'https://dev-gcp.id2.internal.viana.ai/auth/realms/staging/protocol/openid-connect/token',
  client_id: 'viana-portal',
  client_secret: 'c2f34191-5f73-4699-91d2-4283fd97e81c',
  scope: 'openid user',
  superset: {
    baseUrl: 'https://dev-gcp.superset.internal.viana.ai',
    coatro: {
      default: '',
      meldcx: '28bb7b62-7553-4a06-8910-0be4348759be',
      pg: '',
    },
    coeffe: {
      default: '',
      meldcx: '7210dddc-b271-4a9d-99b6-dadf27c4d23d',
      pg: '',
      onq: '174c8458-3896-4990-b571-f5e37c445c9e',
    },
    trafficMeasurement: 'f9abf10e-c5df-420b-be06-4ce3b2712651',
    coffeeVehicle: 'fc1c74d3-21b3-4352-bfd2-b53006b83436'
  },
};

const endpointsDevGCP = {
  environment: 'dev',
  base_url: 'https://dev-gcp.services.api.viana.ai/',
  base_url_insights: 'https://dev-gcp.insights.api.viana.ai/',
  admin_url: 'https://dev-gcp.admin.internal.viana.ai/',
  assets_url: 'https://assets.api.viana.ai/',
  viana_url: 'https://dev-gcp.portal.internal.viana.ai/'
};

const endpointsDevGCP2 = {
  environment: 'dev_gcp.id2',
  base_url: 'https://dev-gcp.services.api.viana.ai/',
  base_url_insights: 'https://dev-gcp.insights.api.viana.ai/',
  admin_url: 'https://dev-gcp.admin.internal.viana.ai/',
  assets_url: 'https://assets.api.viana.ai/',
  viana_url: 'https://dev-gcp.portal.internal.viana.ai/'
  // sentry_dsn: 'https://3c84de2cf4ef48c8b81d9959fa173ad3@sentry.internal.viana.ai/7'
};

const authStaging = {
  auth_url: 'https://dev-gcp.id2.internal.viana.ai/auth',
  realm: 'staging',
  access_token_url: 'https://dev-gcp.id2.internal.viana.ai/auth/realms/staging/protocol/openid-connect/token',
  client_id: 'viana-portal',
  client_secret: 'c2f34191-5f73-4699-91d2-4283fd97e81c',
  scope: 'openid user',
  powerBIReportID: 'e13cb171-aacd-4e9c-b5d9-7a2f24926b10',
  superset: {
    baseUrl: 'https://stg-gcp.superset.internal.viana.ai',
    coatro: {
      default: '',
      meldcx: '0c01b6d2-49d8-4445-bc46-93bf87a98d23',
      pg: '',
      onq: '',
      bsign: 'd0ed51ea-b0e2-42f7-8e58-ade3eed85357',
    },
    coeffe: {
      default: '',
      meldcx: '9e7ccdc7-198a-46d0-b887-661e75acdd81',
      pg: '',
      onq: '',
      bsign: 'b53dc821-9778-49ae-af5b-da61e0008001',
    },
    coatroVehicle: '98bdfdd8-380f-4973-af4a-6af45c4a3520',
    coffeeVehicle: {
      default: '',
      meldcx: 'd477a229-b7b0-4409-a8d5-69e7895bcfdf',
      pg: '',
      onq: '',
      bsign: '4fad9bff-8675-4d67-980b-47c4479aeb63',
    }
  }
};

const endpointsStaging = {
  environment: 'staging',
  base_url: 'https://viana-services-210498958095.australia-southeast2.run.app/',
  base_url_insights: 'https://viana-insights-210498958095.australia-southeast2.run.app/',
  admin_url: 'https://stg-gcp.admin.internal.viana.ai/',
  viana_url: 'https://stg-gcp.portal.internal.viana.ai/',
};

const endpointsStaging2 = {
  environment: 'staging2',
  base_url: 'https://viana-services-staging-copy3.azurewebsites.net/',
  base_url_insights: 'https://viana-insights-staging-auspost.azurewebsites.net/',
  admin_url: 'https://admin.node16poc.internal.viana.ai/',
  viana_url: 'https://staging4.portal.internal.viana.ai//',
  assets_url: 'https://assets.api.viana.ai/'
};

// const authPreproduction = {
//   auth_url: 'https://id.skunkworks.ai/auth',
//   realm: 'preprod',
//   access_token_url: 'https://id.skunkworks.ai/auth/realms/preprod/protocol/openid-connect/token',
//   client_id: 'viana-portal',
//   client_secret: '864a614e-590f-4abf-8cf2-ec3b7ebecaab',
//   scope: 'openid user',
//   powerBIReportID: '6316bc5e-4326-46a5-8151-70566e322041',
//   superset: {
//     baseUrl: 'https://superset-ppd.internal.viana.ai',
//     coatro: 'cdf80baa-55a9-4f3a-b801-34cc90b82720',
//     coeffe: '042f9dd2-ad1a-4c4d-be9d-2dfe36892643',
//     trafficMeasurement: '2f719499-0d2d-49e8-85dd-021ee3de1648'
//   }
// };

const authPreproduction = {
  auth_url: 'https://dev-gcp.id2.internal.viana.ai/auth',
  realm: 'preprod',
  access_token_url: 'https://dev-gcp.id2.internal.viana.ai/auth/realms/preprod/protocol/openid-connect/token',
  client_id: 'viana-portal',
  client_secret: '864a614e-590f-4abf-8cf2-ec3b7ebecaab',
  scope: 'openid user',
  powerBIReportID: '6316bc5e-4326-46a5-8151-70566e322041',
  superset: {
    baseUrl: 'https://ppd-gcp.superset.internal.viana.ai',
    coatro: '9e496afe-2c4f-49b9-be40-49232b72a404',
    coeffe: {
      default: 'f9d573c2-f599-46a9-b03a-a914b7d00798',
      manwharf: '3217ca30-cb32-48f5-aa2d-3f24d8711284',
    },
    coatroVehicle: '2f719499-0d2d-49e8-85dd-021ee3de1648'
  }
};

// const endpointsPreproduction = {
//   environment: 'preproduction',
//   base_url: 'https://ppd.services.api.viana.ai/',
//   base_url_insights: 'https://ppd.insights.api.viana.ai/',
//   admin_url: 'https://prep.admin.internal.viana.ai/',
//   viana_url: 'https://prep.portal.internal.viana.ai/'
// };

const endpointsPreproduction = {
  environment: 'preproduction',
  base_url: 'https://crn-viana-ppd-ausse2-aiservices-939112729767.australia-southeast2.run.app/',
  base_url_insights: 'https://crn-viana-ppd-ausse2-aiinsights-939112729767.australia-southeast2.run.app/',
  admin_url: 'https://ppd-gcp.admin.internal.viana.ai',
  viana_url: 'https://ppd-gcp.portal.internal.viana.ai'
};

const authProduction = {
  auth_url: 'https://id.viana.ai/auth',
  realm: 'production',
  access_token_url: 'https://id.viana.ai/auth/realms/production/protocol/openid-connect/token',
  client_id: 'viana-portal',
  client_secret: '63b58278-28c8-43a8-abc6-7698c0146c90',
  scope: 'openid user',
  powerBIReportID: 'fe0fd6dd-1a69-4964-86bb-35f103aa6577',
  superset: {
    baseUrl: 'https://cortex2.viana.ai',
    coatro: '55b73c53-e5dc-4940-8e9e-91a0b2861a41',
    coeffe: '344a119c-0018-416e-bf61-cdcc7abd2249',
    trafficMeasurement: '6f40e9dc-a93e-4795-bf87-6e949b65c04e'
  }
};

const endpointsProduction2 = {
  environment: 'production',
  base_url: 'https://viana-services-copy.azurewebsites.net/',
  base_url_insights: 'https://viana-insights-production-copy2.azurewebsites.net/',
  admin_url: 'https://admin.viana.ai/',
  viana_url: 'https://admin.viana.ai/',
  assets_url: 'https://assets.api.viana.ai/',
  sentry_dsn: ''
}
const endpointsProduction = {
  environment: 'production',
  base_url: 'https://services.api.viana.ai/',
  base_url_insights: 'https://insights.api.viana.ai/',
  viana_url: 'https://portal.viana.ai/',
  admin_url: 'https://admin.viana.ai/',
  assets_url: 'https://assets.api.viana.ai/',
  sentry_dsn: ''
};

export const auth = process.env.REACT_APP_VIANA_ENV === 'production'
  ? authProduction
  : process.env.REACT_APP_VIANA_ENV === 'production2'
    ?  authProduction
    : process.env.REACT_APP_VIANA_ENV === 'preproduction'
      ? authPreproduction
      : process.env.REACT_APP_VIANA_ENV === 'dev-gcp'
      ? authDevGCP
        : process.env.REACT_APP_VIANA_ENV === 'dev_gcp.id2'
          ? authDevGCP2
          : process.env.REACT_APP_VIANA_ENV === 'dev'
            ? authDev
            : authStaging;

export let endpoints;
if (process.env.REACT_APP_VIANA_ENV === 'production') {
  endpoints = endpointsProduction;
} else if (process.env.REACT_APP_VIANA_ENV === 'production2') {
  endpoints = endpointsProduction2;
} else if (process.env.REACT_APP_VIANA_ENV === 'preproduction') {
  endpoints = endpointsPreproduction;
} else if (process.env.REACT_APP_VIANA_ENV === 'staging2') {
  endpoints = endpointsStaging2;
} else if (process.env.REACT_APP_VIANA_ENV === 'dev-gcp') {
  endpoints = endpointsDevGCP;
} else if(process.env.REACT_APP_VIANA_ENV === 'dev_gcp.id2') {
  endpoints = endpointsDevGCP2;
}  else if (process.env.REACT_APP_VIANA_ENV === 'dev') {
  endpoints = endpointsDev;
}  else {
  endpoints = endpointsStaging;
}

const initOptions = {
  url: auth.auth_url, realm: auth.realm, clientId: auth.client_id, onLoad: 'login-required'
};

const keycloak = new Keycloak(initOptions);
export default keycloak;
